import { gql } from '@apollo/client';
import { samparkApolloClient } from '../config/config.graphql';

const UPDATE_PERMISSION = gql`
  mutation UpdatePermission($userId: ID!, $application: String!, $input: UpdatePermissionInput!) {
    updatePermission(user_id: $userId, application: $application, input: $input) {
      user_id
      application
      access
    }
  }
`;

export function submitApprovalForm(values) {
  return samparkApolloClient
    .mutate({
      mutation: UPDATE_PERMISSION,
      variables: {
        userId: values.user_id,
        application: values.application,
        input: {
          user_id: values.user_id,
          application: values.application,
          access: values.access
        }
      }
    })
    .then((response) => {
      if (response.error) {
        return { error: response.error };
      }
      const updatedPermission = response.data?.updatePermission;
      return updatedPermission
        ? { message: 'Record Updated Successfully.', data: updatedPermission }
        : { error: response };
    })
    .catch((error) => {
      return { error };
    });
}
